export default __webpack_public_path__ + "static/media/Banner_1440x500_Laptop_Grande.7a757f9d.png";